export const fanModeConstants = {
    
    TURN_FAN_MODE_ON_REQUEST: 'TURN_FAN_MODE_ON_REQUEST',
    TURN_FAN_MODE_ON_SUCCESS: 'TURN_FAN_MODE_ON_SUCCESS',

    TURN_FAN_MODE_OFF_REQUEST: 'TURN_FAN_MODE_OFF_REQUEST',
    TURN_FAN_MODE_OFF_SUCCESS: 'TURN_FAN_MODE_OFF_SUCCESS',
}
